import React, { FunctionComponent, memo } from "react";
import { Col, Row } from "antd";
import "./GroupBlocksHeader.scss";
import Loader from "../../../../common/loader/Loader";

const GroupBlocksHeaderLoading: FunctionComponent = () => {
  return (
    <Row
      className="group-blocks-header"
      align={"bottom"}
      justify={"space-between"}
    >
      <Col>
        <h2>Entities</h2>
      </Col>
      <Col>
        <span className="average-text">Avg.</span>
        <span className="loading" style={{ display: "inline-block" }}>
          <Loader size="small" />
        </span>
        %
      </Col>
    </Row>
  );
};

export default memo(GroupBlocksHeaderLoading);
